export const ALL_QUE_ANS_REQUEST = "ALL_QUE_ANS_REQUEST";
export const ALL_QUE_ANS_SUCCESS = "ALL_QUE_ANS_SUCCESS";
export const ALL_QUE_ANS_FAIL = "ALL_QUE_ANS_FAIL";

export const NEW_QUE_ANS_REQUEST = "NEW_QUE_ANS_REQUEST";
export const NEW_QUE_ANS_SUCCESS = "NEW_QUE_ANS_SUCCESS";
export const NEW_QUE_ANS_RESET = "NEW_QUE_ANS_RESET";
export const NEW_QUE_ANS_FAIL = "NEW_QUE_ANS_FAIL";

export const QUE_ANS_DETAILS_REQUEST = "QUE_ANS_DETAILS_REQUEST";
export const QUE_ANS_DETAILS_SUCCESS = "QUE_ANS_DETAILS_SUCCESS";
export const QUE_ANS_DETAILS_FAIL = "QUE_ANS_DETAILS_FAIL";

export const DELETE_QUE_ANS_REQUEST = "DELETE_QUE_ANS_REQUEST";
export const DELETE_QUE_ANS_SUCCESS = "DELETE_QUE_ANS_SUCCESS";
export const DELETE_QUE_ANS_RESET = "DELETE_QUE_ANS_RESET";
export const DELETE_QUE_ANS_FAIL = "DELETE_QUE_ANS_FAIL";

export const NEW_ANSWER_REQUEST = "NEW_ANSWER_REQUEST";
export const NEW_ANSWER_SUCCESS = "NEW_ANSWER_SUCCESS";
export const NEW_ANSWER_RESET = "NEW_ANSWER_RESET";
export const NEW_ANSWER_FAIL = "NEW_ANSWER_FAIL";

export const ALL_ANSWER_REQUEST = "ALL_ANSWER_REQUEST";
export const ALL_ANSWER_SUCCESS = "ALL_ANSWER_SUCCESS";
export const ALL_ANSWER_FAIL = "ALL_ANSWER_FAIL";

export const DELETE_ANSWER_REQUEST = "DELETE_ANSWER_REQUEST";
export const DELETE_ANSWER_SUCCESS = "DELETE_ANSWER_SUCCESS";
export const DELETE_ANSWER_RESET = "DELETE_ANSWER_RESET";
export const DELETE_ANSWER_FAIL = "DELETE_ANSWER_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";